(function () {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.shell:mxSideLayout
	 * @module mx.shell
	 * @restrict 'E'
	 * @scope {}
	 * @requires {@ref mx.shell.SideLayout mx.shell.SideLayout}
	 * @description An aside panel, a placeholder that can be used for some details information
	 * @usage <mx-side-layout>Some transcluded html</mx-side-layout>
	 */
	angular.module('mx.shell').directive('mxSideLayout', function mxSideLayoutDirective() {
		MxSideLayoutCtrl.$inject = ['mx.shell.SideLayout'];

		function MxSideLayoutCtrl(mxSideLayout) {
			var vm = this;

			vm.$onInit = function () {
				vm.mxSideLayout = mxSideLayout;
			};
		}

		return {
			restrict: 'E',
			scope: {},
			bindToController: {},
			controller: MxSideLayoutCtrl,
			controllerAs: 'vm',
			replace: true,
			templateUrl: 'components/mx-side-layout/mx-side-layout.html',
		};
	});
})();
